// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IProfileApi,
  IProfileApiRequest,
  IProfileApiGetAttrs,
  IProfileApiProfileResponse,
  IProfileApiNullResponse,
  IProfileApiUpdateAttrs,
} from 'interfaces/back-office/personal-data/profile/profile-api.interface'

// Constant
import { ApiConstantHc, ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class ProfileApi extends BaseApi<IProfileApi> implements IProfileApiRequest {
  readonly url = ApiConstantHc.PROFILE_URL
  private profileUrl = axios_renderUrl(ApiConstant.PROFILE_URL, ApiConstant.BACK_OFFICE)

  /**
   * @description Get profile
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IProfileApiGetAttrs} payload
   *
   * @return {Promise<IProfileApiProfileResponse>} Promise<IProfileApiProfileResponse>
   */
  async profile_getProfile(payload: IProfileApiGetAttrs): Promise<IProfileApiProfileResponse> {
    return this.POST(`${this.profileUrl}/me`, {}, { ...payload.requestConfig })
  }

  /**
   * @description Update profile
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IProfileApiUpdateAttrs} payload
   *
   * @return {Promise<IProfileApiNullResponse>} Promise<IProfileApiNullResponse>
   */
  async profile_updateProfile(payload: IProfileApiUpdateAttrs): Promise<IProfileApiNullResponse> {
    return this.POST(`${this.profileUrl}/update`, { ...payload.body }, { ...payload.requestConfig })
  }
}
